import React, { Component } from 'react';
import { Badge, Button, Col, Row, Spinner, Modal, Form, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import img1 from '../../assets/images/trans-1.png';
import img2 from '../../assets/images/trans-2.png';
import img3 from '../../assets/images/trans-3.png';
import { t } from '../../helpers/translation_helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { faArrowLeft, faArrowRight, faBell, faBus, faCalendar, faCheck, faChevronLeft, faClock, faPlus, faSearch, faTimes, faXmark } from '@fortawesome/free-solid-svg-icons';
import { GET, POST } from '../../api';
import { toast } from 'react-toastify';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { faCalendarAlt, faClockFour, faCommentDots, faNoteSticky, faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import Pagination from '../_partials/Pagination';
import Select from 'react-select';
var Chance = require('chance');
var chance = new Chance();
const widgetStyle = {
  backgroundColor: '#fff',
  borderRadius: 7,
  padding: '10px 15px',
  height: 200,
  width: '20%',
  marginRight: 14,
  backgroundPosition: 'bottom right',
  backgroundRepeat: 'no-repeat',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  backgroundSize: '60%',
}

class TransportationDashboard extends Component {

  messagesEndRef = React.createRef();
  fetchReq = null

  state = {
    concerns: [],
    totalBusesCount: 0,
    totalRoutesCount: 0,
    totalRegisteredStudentCount: 0,
    cdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'br.route_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      columns: [
        {
          id: 'br.route_id',
          column: 'route_id',
          name: 'ID',
          visibility: true,
          sortable: true,
        },
      ],
      data: [],
    },
    modal: {
      show: false,
      data: null,
      notes: [],
      noteText: '',
      discussions: [],
      discussionText: '',
      open: (data) => {
        this.setState({
          modal: {
            ...this.state.modal,
            show: true,
            data,
            notes: [],
            noteText: '',
            discussions: [],
            discussionText: '',
          }
        });

        // if (data.cnsrn_seen !== 'Read') {
        //   this.markConcernAsRead(data.cnsrn_id);
        // }

        this.getNotes(data.cnsrn_id);
        this.getDiscussions(data.cnsrn_id);
      },
      close: () => {
        this.setState({
          modal: {
            ...this.state.modal,
            show: false,
            data: null,
            notes: [],
            noteText: '',
            discussions: [],
            discussionText: '',
          }
        });
      },
    },
    tagModal: {
      show: false,
      data: null,
      getConcernsTagUsersData: [],
      selectedTagUsers: null,
      open: async (data) => {
        const getConcernsTagUsersData = await this.getConcernsTagUsers();
        this.setState({
          tagModal: {
            ...this.state.tagModal,
            show: true,
            data,
            getConcernsTagUsersData
          }
        });
      },
      close: () => {
        this.setState({
          tagModal: {
            ...this.state.tagModal,
            show: false,
            data: null,
            getConcernsTagUsersData: [],
            selectedTagUsers: null,
          }
        });
      },
    }
  };

  componentDidMount() {

    const { search, rows: limit, order, dir } = this.state.cdt;
    this.fetch({
      search,
      limit,
      order,
      dir,
      page: 0,
    });

    this.getData();
  }


  getData = async () => {
    try {
      const res = await GET('transportation-dashboard/get-widget-data');

      if (res.status === 200) {
        const data = res.data;




        this.setState({
          totalBusesCount: data.total_buses_count,
          totalRoutesCount: data.total_routes_count,
          totalRegisteredStudentCount: data.total_registered_students_count,
        });
      } else {
        console.error('Failed to fetch concern data:', res);
      }

    } catch (err) {
      console.error('Error fetching concern data:', err);
    }
  }

  fetch = async (params) => {
    this.setState({
      cdt: {
        ...this.state.cdt,
        fetching: true,
      },
    });

    if (this.fetchReq) {
      this.fetchReq.abort();
    }

    this.fetchReq = new AbortController();

    try {

      const requestParams = {
        search: params.search,
        order: params.order,
        dir: params.dir,
        limit: params.limit,
        offset: parseInt(params.page) * parseInt(params.limit),
      };

      if (this.state.cnsrn_priority) {
        requestParams.cnsrn_priority = this.state.cnsrn_priority.value;
      }

      if (this.state.cnsrn_status) {
        requestParams.cnsrn_status = this.state.cnsrn_status.value;
      }

      const res = await GET('transportation-dashboard/get', {
        signal: this.fetchReq.signal,
        params: requestParams,
      });

      if (res.status === 200) {
        this.setState({
          cdt: {
            ...this.state.cdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                collapse: true,
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      console.log('err', err);
      this.setState({
        cdt: {
          ...this.state.cdt,
          fetching: false,
        },
      });
    }
  };


  render() {
    const { lang_orientation: dir } = this.props.defaultLanguage;

    // console.log('%cSTATES', 'font-size: 20px; font-weight: bold; color: orange;', this.state);
    // console.log('%cPROPS', 'font-size: 20px; font-weight: bold; color: pink;', this.props);

    return (
      <div className='grey-section mb-0' style={{ marginLeft: 12, borderRadius: 14, padding: 14, height: 'calc(100vh - 135px)', overflowY: 'auto' }}>
        <div style={{ display: 'flex', marginBottom: 14, }}>
          <div style={{
            ...widgetStyle,
            backgroundImage: `url(${img1})`,
          }}>
            <strong>{t('Total Buses')}</strong>
            <div style={{ fontSize: 80, color: '#934DFF', lineHeight: '80px' }}>
              {this.state.totalBusesCount}
            </div>
          </div>
          <div style={{
            ...widgetStyle,
            backgroundImage: `url(${img2})`,
          }}>
            <strong>{t('Total Routes')}</strong>
            <div style={{ fontSize: 80, color: '#83868D', lineHeight: '80px' }}>
              {this.state.totalRoutesCount}
            </div>
          </div>
          <div style={{
            ...widgetStyle,
            backgroundImage: `url(${img3})`,
          }}>
            <strong>{t('Registered Students')}</strong>
            <div style={{ fontSize: 80, color: '#A80000', lineHeight: '80px' }}>
              {this.state.totalRegisteredStudentCount}
            </div>
          </div>
        </div>
        <div
          style={{
            background: '#fff',
            borderRadius: 7,
            alignItems: 'center',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            minHeight: 'calc(100vh - 377px)',
          }}>
          <div style={{ borderTop: '#f2f2f2 1px solid', height: 'calc(100vh - 442px)', overflowY: 'auto', borderBottom: '1px solid #f2f2f2', }}>
            {this.state.cdt.fetching &&
              <div
                style={{ flex: 1 }}
                className='p-5 d-flex flex-column align-items-center justify-content-center'>
                <Spinner as='span' animation='grow' size='sm' />{' '}
                {t('Loading Data')}
              </div>
            }
            {!this.state.cdt.fetching && this.state.cdt.data.length === 0 &&
              <div
                style={{ flex: 1 }}
                className='p-5 d-flex flex-column align-items-center justify-content-center'>
                {t('No Data Found')}
              </div>
            }
            {(!this.state.cdt.fetching && this.state.cdt.data.length !== 0) &&
              this.state.cdt.data.map((item, index) =>
                <div key={index}
                  style={{
                    padding: 20,
                    borderBottom: index === this.state.cdt.data.length - 1 ? 'none' : '1px solid #f2f2f2',
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <div>
                    <FontAwesomeIcon icon={faBus} style={{ color: '#6D7179', marginRight: 15, fontSize: 20 }} />
                  </div>
                  <div style={{
                    width: 110,
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <span style={{
                      border: '1px solid #000',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      borderRadius: 5,
                      padding: '2px 5px',
                    }}>{item.plate_num}</span>
                  </div>
                  <div style={{ flex: 1 }}>{item.bus_desc}</div>
                  <div title={t('Incoming')} className='d-flex align-items-center' style={{
                    width: 350,
                    paddingRight: 30
                  }}>
                    <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: 10, color: '#23A21D', marginRight: 10 }} />
                    <img src={require('../../assets/images/seat-green.png')} style={{ marginRight: 10 }} alt='Seats' />
                    <strong style={{ color: '#23A21D', width: 30 }}>{item.incoming_count}</strong>
                    <div style={{ flex: 1 }}>
                      <div style={{
                        width: '100%',
                        height: 6,
                        backgroundColor: '#f5f5f5',
                        borderRadius: 6 / 2,
                        overflow: 'hidden',
                      }}>
                        <div style={{
                          width: `${item.seat_num > 0 ? Math.min((item.incoming_count / item.seat_num) * 100, 100) : 0}%`,
                          height: '100%',
                          backgroundColor: '#D2EDCC',
                          borderRadius: 6 / 2,
                        }}></div>
                      </div>
                    </div>
                    <strong className='text-end' style={{ color: '#A0A3A8', width: 30 }}>{item.seat_num}</strong>
                  </div>
                  <div title={t('Returning')} className='d-flex align-items-center' style={{
                    width: 350
                  }}>
                    <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: 10, color: '#458BEE', marginRight: 10 }} />
                    <img src={require('../../assets/images/seat-blue.png')} style={{ marginRight: 10 }} alt='Seats' />
                    <strong style={{ color: '#458BEE', width: 30 }}>{item.returning_count}</strong>
                    <div style={{ flex: 1 }}>
                      <div style={{
                        width: '100%',
                        height: 6,
                        backgroundColor: '#f5f5f5',
                        borderRadius: 6 / 2,
                      }}>
                        <div style={{
                          width: `${item.seat_num > 0 ? Math.min((item.returning_count / item.seat_num) * 100, 100) : 0}%`,
                          height: '100%',
                          backgroundColor: '#cadeff',
                          borderRadius: 6 / 2,
                        }}></div>
                      </div>
                    </div>
                    <strong className='text-end' style={{ color: '#A0A3A8', width: 30 }}>{item.seat_num}</strong>
                  </div>
                </div>
              )
            }
          </div>
          <div className='px-3' style={{ paddingTop: 13, }}>
            <Pagination
              pageCount={this.state.cdt.lastPage || 1}
              forcePage={this.state.cdt.page}
              callbackParams={{
                search: this.state.cdt.search,
                limit: this.state.cdt.rows,
                order: this.state.cdt.order,
                dir: this.state.cdt.dir,
              }}
              callback={this.fetch}
            />
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(TransportationDashboard);
